import { createSlice } from "@reduxjs/toolkit"

import { ChatState } from "@/store/types"
import { chatsApi } from '@/api/chats/chats.api'

const initialState: ChatState = {
  loader: {
    contacts: false,
    room: false,
  },
  error: "",
  messages: [],
  conversations: [],
  unread: {}
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    // onConversationAdded: (state, action) => {
    //   state.conversations = [...state.conversations, action.payload].sort((a, b) => Number(b.lastMessageSentAt) - Number(a.lastMessageSentAt));
    // },
    // onMessageReceived: (state, action: { payload: UserMessageDto }) => {
    //   const conversationId = action.payload.chatId;
    //   const chat = state.conversations.find(chat => chat.id === conversationId);
    //
    //   if(!chat) {
    //     return state;
    //   }
    //
    //   chat.lastMessagePreview = action.payload.message;
    //   chat.lastMessageSentAt = action.payload.created;
    //   chat.lastMessageUserId = action.payload.userId;
    //   const conv = state.conversations.filter(c => c.id !== chat.id);
    //   state.conversations = [chat, ...conv].sort((a, b) => Number(b.lastMessageSentAt) - Number(a.lastMessageSentAt));
    //
    //   // if(conversation?.id !== state.conversation?.id) {
    //   //   const unread = state.unread[conversation.id] || 0;
    //   //   state.unread = { ...state.unread, [conversation.id]: unread + 1 }
    //   //
    //   //   return state;
    //   // }
    //
    //   state.messages = [action.payload, ...state.messages];
    // },
  },
  extraReducers: (builder) => {
    // builder
      // .addCase(getConversations.pending, (state) => {
      //   state.loader.contacts = true;
      //   state.conversations = [];
      //   state.error = "";
      // })
      // .addCase(getConversations.fulfilled, (state, { payload }) => {
      //   state.loader.contacts = false;
      //   state.conversations = [...payload].sort((a, b) => Number(b.lastMessageSentAt) - Number(a.lastMessageSentAt));
      // })
      // .addCase(getConversations.rejected, (state, action: any & { payload: ServerError }) => {
      //   state.loader.contacts = false;
      //   state.error = action.payload.message;
      // })
      // .addCase(getConversationMessages.pending, (state) => {
      //   state.loader.contacts = true;
      //   state.error = "";
      //   state.messages = [];
      // })
      // .addCase(getConversationMessages.fulfilled, (state, { payload }) => {
      //   state.loader.contacts = false;
      //   state.messages = payload;
      // })
      // .addCase(getConversationMessages.rejected, (state, action: any & { payload: ServerError }) => {
      //   state.loader.contacts = false;
      //   state.error = action.payload.message;
      // })
      // .addCase(getUnreadConversationMessages.pending, (state) => {
      //   state.loader.contacts = true;
      //   state.error = "";
      // })
      // .addCase(getUnreadConversationMessages.fulfilled, (state, { payload }) => {
      //   state.loader.contacts = false;
      //   state.unread = { ...state.unread, [payload.conversationId]: payload.unread };
      // })
      // .addCase(getUnreadConversationMessages.rejected, (state, action: any & { payload: ServerError }) => {
      //   state.loader.contacts = false;
      //   state.error = action.payload.message;
      // })
      // .addCase(readConversationMessages.pending, (state) => {
      //   state.loader.contacts = true;
      //   state.error = "";
      // })
      // .addCase(readConversationMessages.fulfilled, (state, { payload }) => {
      //   state.loader.contacts = false;
      //   // CHECK: if needed
      //   // const conversation = state.conversation;
      //   // if(!conversation) {
      //   //   return state;
      //   // }
      //
      //   // state.unread = { ...state.unread, [conversation.id]: 0 };
      // })
      // .addCase(readConversationMessages.rejected, (state, action: any & { payload: ServerError }) => {
      //   state.loader.contacts = false;
      //   state.error = action.payload.message;
      // })
    
    
    builder
      .addMatcher(chatsApi.endpoints.getAllChats.matchPending, (state) => {
        state.loader.contacts = true;
        state.conversations = [];
        state.error = "";
      })
      .addMatcher(chatsApi.endpoints.getAllChats.matchFulfilled, (state, { payload}) => {
        state.loader.contacts = false;
        state.conversations = [...payload].sort((a, b) => Number(b.lastMessage?.created) - Number(a.lastMessage?.created));
      })
      .addMatcher(chatsApi.endpoints.getAllChats.matchRejected, (state, { payload}) => {
        state.loader.contacts = false;
        state.error = payload?.data?.toString() ?? 'Something went wrong';
      })
      
      .addMatcher(chatsApi.endpoints.getChatMessages.matchPending, (state) => {
        state.loader.contacts = true;
        state.error = "";
        state.messages = [];
      })
      .addMatcher(chatsApi.endpoints.getChatMessages.matchFulfilled, (state, { payload}) => {
        state.loader.contacts = false;
        state.messages = payload;
      })
      .addMatcher(chatsApi.endpoints.getChatMessages.matchRejected, (state, { payload}) => {
        state.loader.contacts = false;
        state.error = payload?.data?.toString() ?? 'Something went wrong';
      })
      
      .addMatcher(chatsApi.endpoints.readChatMessages.matchPending, (state) => {
        state.loader.contacts = true;
        state.error = "";
      })
      .addMatcher(chatsApi.endpoints.readChatMessages.matchFulfilled, (state, { payload}) => {
        state.loader.contacts = false;
        // CHECK: if needed
        // const conversation = state.conversation;
        // if(!conversation) {
        //   return state;
        // }
        
        // state.unread = { ...state.unread, [conversation.id]: 0 };
      })
      .addMatcher(chatsApi.endpoints.readChatMessages.matchRejected, (state, { payload}) => {
        state.loader.contacts = false;
        state.error = payload?.data?.toString() ?? 'Something went wrong';
      })
      
      // .addMatcher(chatsApi.endpoints.getUnreadChatMessages.matchPending, (state) => {
      //   state.loader.contacts = true;
      //   state.error = "";
      // })
      // .addMatcher(chatsApi.endpoints.getUnreadChatMessages.matchFulfilled, (state, { payload}) => {
      //   state.loader.contacts = false;
      //   state.unread = { ...state.unread, [payload.conversationId]: payload.unread };
      // })
      // .addMatcher(chatsApi.endpoints.getUnreadChatMessages.matchRejected, (state, { payload}) => {
      //   state.loader.contacts = false;
      //   state.error = payload?.data?.toString() ?? 'Something went wrong';
      // })
  }
});


export const actions = chatSlice.actions;
export default chatSlice.reducer;
